import { MultipleChoiceQuestionDownloadDto } from 'collaboration-service';
import * as React from 'react';
import EditPartContainer, { EditPartContainerType } from '../EditPartContainer';
import EditPartLabelAndEditor from '../EditPartLabelAndEditor';
import EditAnswers from '../Editors/EditAnswers';
import EditBoolean from '../Editors/EditBoolean';
import GenPropQuestion from './GenPropQuestion';
import PrePostFixQuestion from './PrePostFixQuestion';

interface PostEditQuizMultipleChoiceQuestionProps {
    epc: EditPartContainerType;
    registerClosed?: boolean;
}

const PostEditQuizMultipleChoiceQuestion = (p: PostEditQuizMultipleChoiceQuestionProps) => {
    const { epc, registerClosed } = p;

    return (
        <>
            <GenPropQuestion epc={epc} registerClosed={registerClosed} />
            <EditPartContainer icon="asking" title="possible answers" {...epc} >
                <EditPartLabelAndEditor>
                    {[
                        { label: { icon: "game", content: "single choice" }, editor: <EditBoolean<MultipleChoiceQuestionDownloadDto> getter={x => x.singleChoice} /> },
                        { label: { icon: "tag", content: "answers" }, editor: <EditAnswers< MultipleChoiceQuestionDownloadDto> getter={x => x.possibleAnswers} /> },
                    ]}
                </EditPartLabelAndEditor>
            </EditPartContainer>
            <PrePostFixQuestion epc={epc} registerClosed={registerClosed} />
        </>
    );
}
export default PostEditQuizMultipleChoiceQuestion;